import { render, staticRenderFns } from "./RecoveryCheckDialog.vue?vue&type=template&id=fdfb0c2c&"
import script from "./RecoveryCheckDialog.vue?vue&type=script&lang=js&"
export * from "./RecoveryCheckDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports